import { render, staticRenderFns } from "./tag-manager.vue?vue&type=template&id=0646dd24&scoped=true&"
import script from "./tag-manager.vue?vue&type=script&lang=js&"
export * from "./tag-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646dd24",
  null
  
)

export default component.exports